import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import { RulesetCard } from '../../Notification/Rulesets/RulesetCard';
import { shortDefs } from '../../../ArbitrationObjects/ListControlArbitrator/shortDefs';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const RulesetCardWidget = (props) => {
    const component = useMemo(() => (_jsx(_Fragment, { children: props.contextCustomer && (_jsx(RulesetCard, { seedCustomer: props.contextCustomer, viewObject: {
                matchedPrimary: {
                    name: 'Ruleset',
                    description: 'This is an example ruleset',
                    type: 'Ruleset',
                    pk: '',
                    sk: '',
                    id: '',
                },
                matchedRelatedByPk: undefined,
                matchedRelatedBySk: undefined,
                largeObject: undefined,
            }, allowedActions: shortDefs.noAction, user: props.user, contextCustomer: props.contextCustomer, isSmallView: false, userFunctions: props.userFunctions, userGroupRoles: props.userGroupRoles, userSelectedGroup: props.userSelectedGroup })) })), [props.contextCustomer]);
    return {
        name: 'RulesetCard',
        category: 'common',
        component,
    };
};
